// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gpD9h","newExpiryDate":"styles_newExpiryDate__3znjH","footer":"styles_footer__1CWzJ"};